import { render, staticRenderFns } from "./csvview.vue?vue&type=template&id=38137c68&scoped=true&"
import script from "./csvview.vue?vue&type=script&lang=js&"
export * from "./csvview.vue?vue&type=script&lang=js&"
import style0 from "./csvview.vue?vue&type=style&index=0&id=38137c68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38137c68",
  null
  
)

export default component.exports